import { render, staticRenderFns } from "./IconLeftArrow.vue?vue&type=template&id=248372dd&"
import script from "./IconLeftArrow.vue?vue&type=script&lang=ts&"
export * from "./IconLeftArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports